import React from 'react'
import PropTypes from 'prop-types'
import { Grid, makeStyles } from '@material-ui/core'
import DynamicFieldRenderer from './DynamicFieldRenderer'
import { sortByOrdinal } from './utils/fieldUtils'

const useStyles = makeStyles(() => ({
  groupContainer: {
    marginBottom: 'var(--margin-lg)'
  },
  groupTitle: {
    fontSize: 'var(--text-size-lg)',
    fontWeight: 'var(--text-weight-bold)',
    marginBottom: 'var(--margin-md)',
    color: 'var(--color-primary-700)'
  },
  groupDescription: {
    fontSize: 'var(--text-size-sm)',
    color: 'var(--color-neutral-600)',
    marginBottom: 'var(--margin-md)'
  }
}))

function FieldGroup ({ group, control, form, initializationData }) {
  const classes = useStyles()

  // Sort fields by ordinal
  const sortedFields = sortByOrdinal(group.fields || [])

  return (
    <div className={classes.groupContainer}>
      {group.title && (
        <div className={classes.groupTitle}>{group.title}</div>
      )}
      {group.description && (
        <div className={classes.groupDescription}>{group.description}</div>
      )}
      <Grid container spacing={2}>
        {sortedFields.map(field => (
          <DynamicFieldRenderer
            key={field.id}
            field={field}
            control={control}
            form={form}
            initializationData={initializationData}
          />
        ))}
      </Grid>
    </div>
  )
}

FieldGroup.propTypes = {
  group: PropTypes.shape({
    ordinal: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  initializationData: PropTypes.any
}

export default FieldGroup
